import { cyan, gold, lime, orange, purple, red, volcano, yellow } from '@ant-design/colors';

export const lineColors = [
    cyan[6],
    red[3],
    orange[4],
    yellow[5],
    lime[5],
    cyan[2],
    purple[2],
    red[5],
    red[9],
    volcano[5],
    volcano[9],
    purple[5],
    purple[9],
    cyan[5],
    cyan[9],
    lime[2],
    lime[9],
    gold[2],
    gold[9],
];
